var map = {
	"./template-1/syndicate/syndicate": "app/styles/client/templates/template-1/syndicate/syndicate",
	"./template-10/syndicate/syndicate": "app/styles/client/templates/template-10/syndicate/syndicate",
	"./template-11/syndicate/syndicate": "app/styles/client/templates/template-11/syndicate/syndicate",
	"./template-2/syndicate/syndicate": "app/styles/client/templates/template-2/syndicate/syndicate",
	"./template-3/syndicate/syndicate": "app/styles/client/templates/template-3/syndicate/syndicate",
	"./template-4/syndicate/syndicate": "app/styles/client/templates/template-4/syndicate/syndicate",
	"./template-5/syndicate/syndicate": "app/styles/client/templates/template-5/syndicate/syndicate",
	"./template-6/syndicate/syndicate": "app/styles/client/templates/template-6/syndicate/syndicate",
	"./template-7/syndicate/syndicate": "app/styles/client/templates/template-7/syndicate/syndicate",
	"./template-8/syndicate/syndicate": "app/styles/client/templates/template-8/syndicate/syndicate",
	"./template-9/syndicate/syndicate": "app/styles/client/templates/template-9/syndicate/syndicate"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1638;